import { styleThresholds } from "../resources/styleThresholds";

const CheckStyleThreshold = () => {

    return (
        window.innerWidth <= styleThresholds.width ||
        window.innerHeight <= styleThresholds.height
      )
}

export default CheckStyleThreshold;